import { render, staticRenderFns } from "./ReportMaterialsConsuming.vue?vue&type=template&id=ff596154&scoped=true&"
import script from "./ReportMaterialsConsuming.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsConsuming.vue?vue&type=script&lang=js&"
import style0 from "./ReportMaterialsConsuming.vue?vue&type=style&index=0&id=ff596154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff596154",
  null
  
)

export default component.exports
import {QBtn,QExpansionItem,QItemSection,QIcon} from 'quasar'
component.options.components = Object.assign({QBtn,QExpansionItem,QItemSection,QIcon}, component.options.components || {})
